/**
 * Choice lists for the CRM enrichment fields shipped with migration
 * 20260808200000: lifecycle stage, source attribution, preferred contact
 * method, and the separate email/SMS consent states enforced server-side
 * by compose_message and the sequence engine.
 */

export const LIFECYCLE_STAGE_CHOICES = [
  { id: "subscriber", name: "Subscriber" },
  { id: "lead", name: "Lead" },
  { id: "qualified_lead", name: "Qualified Lead" },
  { id: "opportunity", name: "Opportunity" },
  { id: "customer", name: "Customer" },
  { id: "repeat_customer", name: "Repeat Customer" },
  { id: "lost", name: "Lost" },
  { id: "inactive", name: "Inactive" },
];

export const LEAD_SOURCE_CHOICES = [
  { id: "website", name: "Website" },
  { id: "booking_page", name: "Online Booking" },
  { id: "web_form", name: "Web Form" },
  { id: "referral", name: "Referral" },
  { id: "google", name: "Google / Search" },
  { id: "facebook_ads", name: "Facebook Ads" },
  { id: "phone_call", name: "Phone Call" },
  { id: "walk_in", name: "Walk-in" },
  { id: "door_hanger", name: "Door Hanger / Flyer" },
  { id: "home_show", name: "Home Show / Event" },
  { id: "other", name: "Other" },
];

export const PREFERRED_CONTACT_METHOD_CHOICES = [
  { id: "any", name: "Any" },
  { id: "email", name: "Email" },
  { id: "phone", name: "Phone" },
  { id: "sms", name: "Text (SMS)" },
];

export const EMAIL_CONSENT_CHOICES = [
  { id: "unknown", name: "Unknown" },
  { id: "granted", name: "Granted" },
  { id: "unsubscribed", name: "Unsubscribed" },
];

export const SMS_CONSENT_CHOICES = [
  { id: "unknown", name: "Unknown" },
  { id: "granted", name: "Granted" },
  { id: "opted_out", name: "Opted out" },
];

export const lifecycleStageLabel = (id?: string | null) =>
  LIFECYCLE_STAGE_CHOICES.find((c) => c.id === id)?.name ?? id ?? "n/a";

export const leadSourceLabel = (id?: string | null) =>
  LEAD_SOURCE_CHOICES.find((c) => c.id === id)?.name ?? id ?? "n/a";
